import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import Sloth from 'assets/sloth_invitation_expired.svg';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import { browserHistory } from 'react-router';

const StyledImg = styled.img`
  width: 180px;
  height: 180px;
  ${media.mobile`
    width: 150px;
    height: 150px;
  `};
`;

const StyledContainer = styled.div`
  margin-top: 50px;
  padding: 32px;
  background: #ffffff;
  box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.10301);
  border-radius: 12px;
  max-width: 425px;
`;

const StyledHeader = styled.h1`
  font-weight: 600;
  font-size: 24px;
`;

const StyledP = styled.p`
  font-size: 16px;
`;

const StyledBoldP = styled.p`
  font-size: 16px;
  font-weight: 600;
`;

const StyledLink = styled.a`
  color: #2000ff !important;
  font-weight: 800;
  margin-top: 16px;
`;

class InvalidInvitationToken extends React.Component {
  redirectToPortalLink = () => {
    const currentLocation = browserHistory.getCurrentLocation();
    const query = currentLocation.query;

    if (query.user_type === 'agent') {
      return window.origin + '/companies';
    }

    if (query.user_type === 'maintenance') {
      return window.origin + '/maintenance';
    }

    if (query.user_type === 'lead') {
      return window.origin + '/';
    }
  };

  render() {
    return (
      <StyledContainer>
        <StyledImg
          src={Sloth}
          alt={getTranslatedString('onboarding.tenant.contactNewInvitationLogInImageHelper')}
        />
        <StyledHeader>{getTranslatedString('onboarding.tenant.invitationExpired')}</StyledHeader>
        <StyledP>{getTranslatedString('onboarding.tenant.contactNewInvitation')}</StyledP>
        <hr />
        <StyledBoldP>
          {getTranslatedString('onboarding.tenant.invitationExpiredAlreadyRegistered')}
        </StyledBoldP>
        <StyledP>
          {getTranslatedString('onboarding.tenant.contactNewInvitationAlreadyRegistered')}
        </StyledP>
        <StyledLink
          href={this.redirectToPortalLink()}
          type="button"
          className="link-button"
          style={{ color: 'inherit' }}
        >
          {getTranslatedString('onboarding.tenant.contactNewInvitationLogIn')}
        </StyledLink>
      </StyledContainer>
    );
  }
}

export default InvalidInvitationToken;
